import {
    ParametrosAplicativoInicial,
} from "../models/parametrosAplicativoModel"
import type { ParametrosAplicativoModel } from "../models/parametrosAplicativoModel"
import { ParametrosAplicativoActionsTypes } from "./parametrosAplicativoActions"
import type { ParametrosAplicativoActionModel } from "./parametrosAplicativoActions"

export function parametrosAplicativoReducer(
    state: ParametrosAplicativoModel,
    action: ParametrosAplicativoActionModel
): ParametrosAplicativoModel {
    switch (action.type) {
        case ParametrosAplicativoActionsTypes.CARREGAR:
            return action.payload

        case ParametrosAplicativoActionsTypes.ATUALIZAR_CAMPO:
            return {
                ...state,
                [action.payload.campo]: action.payload.valor,
            }

        case ParametrosAplicativoActionsTypes.RESETAR:
            return ParametrosAplicativoInicial

        default:
            return state
    }
}

export { ParametrosAplicativoInicial }
